var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"ImprovementPost","size":"lg","title":_vm.postData.title,"hide-footer":""}},[_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('post',{attrs:{"postItem":_vm.postData,"categoriesData":_vm.postData.categories}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }